<template>
	<div class="upload-btn-wrapper">
		<!-- Файл -->
		<div class="flex-grow-1" :class="{'mr-1': showDescription}">
			<div v-show="loading" class="smallLoader"></div>
			<div v-show="!loading" class="input-group">
				<input v-if="!hideFileName" type="text" class="form-control pl-1" readonly v-model="file.fileName" :title="file.fileName" />
				<span class="input-group-append pointer" :title="$t('addFile')" style="position:relative" v-if="!readonly && editable">
					<input type="file" :name="name" :id="'file' + _uid" @change="fileChanged" class="w-100" :accept="acceptFilter" />
					<span class="input-group-text bg-primary text-white px-2" v-if="!file.id">
						<i class="fas fa-file-upload"></i>
					</span>
				</span>
				<span class="input-group-append pointer" :title="$t('downloadFile')" v-if="file.id">
					<button type="button"
							class="btn btn-link btn-primary text-left col-6 m-0"
							@click.stop="download">
						<i class="fas fa-file-download"></i>
					</button>
				</span>
			</div>
		</div>
		<!-- Дата -->

		<!-- Описание -->
		<div v-if="showDescription" class="flex-grow-1 ml-1">
			<input type="text" class="form-control" :placeholder="$t('description')" v-model="file.fileDescription" :readonly="editable" />
		</div>
		<div class="d-flex align-items-center" v-if="file.fileName && (!readonly && removable)">
			<span class="input-group-text text-danger px-2 pointer" :title="$t('remove')" @click="removeFile">
				<i class="fas fa-trash"></i>
			</span>
		</div>
	</div>
</template>

<script>
import { File } from '@/models/file.models';

export default {
	props: {
		name: {
			type: String,
			default: 'files'
		},
		file: {
			type: [File, Object],
			default: () => new File({})
		},
		showDescription: {
			type: Boolean,
			default: true
		},
		path: {
			type: String,
            default: 'api/file/download'
		},
		editable: {
			type: Boolean,
			default: true
		},
		removable: {
			type: Boolean,
			default: true
		},
		readonly: {
			type: Boolean,
			default: false
		},
        type: {
            type: String,
            default: ''
        },
        hideFileName: {
            type: Boolean,
            default: false
        },
        acceptFilter: {
            type: String,
            default() {
                return '';
            }
        }
	},
    data() {
        return {
            loading: false
        };
    },
	methods: {
		fileChanged(event) {
			if (event.target.files.length > 0) {
				this.file.id = 0;
				this.file.content = event.target.files[0];
				this.file.fileName = event.target.files[0].name;
				this.$emit('change', this.file);
			}
		},
		removeFile(event) {
			$(this.$el)
				.find('input[type="file"]')
				.val('');

			this.file.id = 0;
			this.file.fileName = '';
			this.file.fileDescription = '';
			this.file.content = null;
			this.$emit('removeFile', this.file._id);
		},
        download() {
            const downloadUri = `${this.$store.getters.baseUrl}/${this.path}?id=${this.file.id}&type=${this.type}&hash=${this.file.hash}`;
            this.loading = true;

            this.$http.get(downloadUri, { responseType: 'blob' })
                .then(response => {
                    const blob = new Blob([response.data]);
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.target = "_blank";
                    link.setAttribute('download', (this.file.name || this.file.fileName)); // or any other extension
                    document.body.appendChild(link);
                    link.click();
                    window.URL.revokeObjectURL(url);
                })
                .catch(err => {
                    this.$vs.notify({
                        color: 'danger',
                        title: this.$t('notifications.error'),
                        text: this.$helpers.errorText(err)
                    })
                })
                .then(() => { this.loading = false; });
        }
	},
	mounted() {
		this.file.uid = this._uid;
	}
};
</script>

<style scoped>
.upload-btn-wrapper {
	position: relative;
	overflow: hidden;
	display: flex;
	justify-content: space-between;
}

.upload-btn-wrapper input[type='file'] {
	font-size: 100px;
	position: absolute;
	left: 0;
	top: 0;
	bottom: 0;
	right: 0;
	opacity: 0;
	cursor: pointer;
}

.pointer:hover {
	cursor: pointer;
}
</style>
